import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: hidden;\n\n  .TransformComponent-module_container__3NwNd {\n    @media (max-width: ', ') {\n      height: 300px;\n    }\n  }\n\n  .TransformComponent-module_content__TZU5O {\n    display: block;\n    max-height: 500px;\n    height: inherit;\n    @media (max-width: ', ') {\n      max-height: 300px;\n      width: ', ';\n    }\n  }\n'], ['\n  position: relative;\n  overflow: hidden;\n\n  .TransformComponent-module_container__3NwNd {\n    @media (max-width: ', ') {\n      height: 300px;\n    }\n  }\n\n  .TransformComponent-module_content__TZU5O {\n    display: block;\n    max-height: 500px;\n    height: inherit;\n    @media (max-width: ', ') {\n      max-height: 300px;\n      width: ', ';\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 75px;\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 75px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  transform: ', ';\n\n  @media (max-width: ', ') {\n    transform: none;\n    height: inherit;\n    width: auto;\n    max-width: unset;\n  }\n'], ['\n  transform: ', ';\n\n  @media (max-width: ', ') {\n    transform: none;\n    height: inherit;\n    width: auto;\n    max-width: unset;\n  }\n']);

import styled from 'styled-components';

export var StyledContainer = styled.div(_templateObject, function (props) {
  return props.theme.mobileWidth;
}, function (props) {
  return props.theme.mobileWidth;
}, function (_ref) {
  var wide = _ref.wide;
  return wide ? '140%' : '110%';
});

export var StyledIcon = styled.img(_templateObject2);

export var StyledImage = styled.img(_templateObject3, function (_ref2) {
  var wide = _ref2.wide;
  return wide ? 'none' : 'translateY(-100px)';
}, function (props) {
  return props.theme.mobileWidth;
});